<template>
    <label
        class="kgr-inputGroup"
        :class="{ 'kgr-inputGroup--inline': inline }"
    >
        <div
            v-if="label !== null"
            class="kgr-inputGroup__label"
        >
            {{ label }}
        </div>
        <kgr-loading
            v-if="loading"
            inline
        />
        <kgr-generic-select
            v-else
            :value="currentValue"
            :options="options"
            :option-key="optionKey"
            :display="display"
            :loading="loading"
            :no-null-option="noNullOption"
            :default-text="defaultText"
            :disabled="disabled"
            :translate-values="translateValues"
            @post-input="handleInput"
        />
    </label>
</template>

<script>
import GenericSelect from './GenericSelect.vue';
import Loading from '../../Loading.vue';

export default {
    components: {
        'kgr-generic-select': GenericSelect,
        'kgr-loading': Loading,
    },
    props: {
        options: {
            type: Array,
            required: true,
        },
        value: {
            type: Object,
            required: false,
            default: null,
        },
        optionKey: {
            type: String,
            required: false,
            default: null,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        defaultText: {
            type: String,
            required: false,
            default: null,
        },
        display: {
            type: String,
            required: true,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        noNullOption: {
            type: Boolean,
            required: false,
            default: false,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        translateValues: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    emits: ['input'],

    data() {
        return {
            currentValue: this.value,
        };
    },

    watch: {
        value(newVal) {
            if (newVal === this.currentValue) {
                return;
            }
            this.currentValue = newVal;
        },
    },

    methods: {
        handleInput(selected) {
            this.currentValue = selected;
            this.$emit('input', selected);
            this.$nextTick(() => {
                this.$emit('post-input', selected);
            });
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
